import React from 'react';
import Picture from '@Theme/natucare/components/Picture/Picture';
import Heading from './components/Heading/Heading';
import Description from './components/Description/Description';
import { tilePropTypes } from './TilePropTypes';
import * as styles from './Tile.module.scss';
const Tile = ({
  heading,
  description,
  picture,
  external,
  url
}) => {
  if (!heading && !(picture !== null && picture !== void 0 && picture.src)) {
    return null;
  }
  const targetBlank = {
    target: '_blank',
    rel: 'noopener'
  };
  return /*#__PURE__*/React.createElement("a", Object.assign({
    href: url
  }, targetBlank, {
    className: `${styles.root} ${external ? styles.rootExternal : ''}`
  }), (picture === null || picture === void 0 ? void 0 : picture.src) && (picture === null || picture === void 0 ? void 0 : picture.alt) && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.src
    },
    alt: picture.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  }), heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootBody
  }, heading && /*#__PURE__*/React.createElement(Heading, {
    heading: heading,
    classname: `${styles.rootHeading} ${description && styles.rootHeadingCut}`
  }), description && /*#__PURE__*/React.createElement(Description, {
    description: description,
    classname: styles.rootDescription
  })));
};
export default Tile;